import { Typography } from '@mui/material';
import { RequiredIcon } from '@vayufp/coast-components';
import React from 'react';

type Props = {
  children: React.ReactNode;
};

const RequiredText: React.FC<Props> = ({ children }: Props) => (
  <>
    <Typography variant="inherit" component="span" color="required.main" mr={1}>
      <RequiredIcon style={{ width: '7', height: '15' }} fill="currentColor" />
    </Typography>
    {children}
  </>
);

export { RequiredText };
